import React from "react";
import styles from "./PointTable.module.scss";
import ninePoint from "../../img/pointTable/9point.png";
import sevenPoint from "../../img/pointTable/7point.png";
import fivePoint from "../../img/pointTable/5point.png";
import threePoint from "../../img/pointTable/3point.png";
import icecreamIcon from "../../img/pointTable/icecream.png";
import pointTable from "../../img/pointTable/pointTable.png";
import blackIcon from "../../img/pointTable/blackIcon.png";
import greenIcon from "../../img/pointTable/greenIcon.png";
const PointTable = ({ pointTableRef }) => {
  return (
    <div className={styles.container} ref={pointTableRef}>
      <div className={styles.contents_box}>
        <img className={styles.icecream} src={icecreamIcon} alt="icon" />
        <img className={styles.nine_point_black_icon} src={blackIcon} alt="" />
        <img className={styles.green_icon} src={greenIcon} alt="icon" />
        <div className={styles.point_prize_box}>
          <div>
            <img className={styles.nine_point} src={ninePoint} alt="icon" />
            <div>
              <span>9 points</span>
              <span>$50,000</span>
            </div>
          </div>
          <div>
            <img className={styles.seven_point} src={sevenPoint} alt="icon" />
            <div>
              <span>7 - 8 points</span>
              <span>$20,000</span>
            </div>
            <img
              className={styles.seven_point_black}
              src={blackIcon}
              alt="icon"
            />
          </div>
          <div>
            <img className={styles.five_point} src={fivePoint} alt="icon" />
            <div>
              <span>5 - 6 points</span>
              <span>$10,000</span>
            </div>
          </div>
          <div>
            <img className={styles.three_point} src={threePoint} alt="icon" />
            <div>
              <span>3 - 4 points</span>
              <span>$5,000</span>
            </div>
          </div>
        </div>
        <div className={styles.point_table_box}>
          <h1 data-content="Points Table">Points Table</h1>
          <img src={pointTable} alt="table" />
        </div>
      </div>
    </div>
  );
};

export default PointTable;
